<template>
  <div id="userInfo">
    <div class="nav">
      <img src=".././assets/img/箭头 (3).png" @click="goActive" />
      填写信息
    </div>
    <div class="userInfo">
      <div class="box">
        <label>手机号：</label>
        <input type="number" v-model="mobile" />
      </div>
      <div class="box">
        <span v-show="showTime" class="getCode" @click="getCode">获取验证码</span>
        <span v-show="!showTime" class="getCode1">{{count}} 秒</span>
        <label>验证码：</label>
        <input type="number" v-model="verify_code" />
      </div>
      <div class="box">
        <label>收货人：</label>
        <input type="text" v-model="user_name" />
      </div>
      <div class="box">
        <!-- <label>收货地址：</label> -->
        <!-- <input type="text"> -->

        <van-cell is-link @click="showPopup" v-model="carmodel">收货地址：{{carmodel}}</van-cell>
        <van-popup v-model="show" position="bottom">
          <van-area
            ref="myArea"
            :area-list="areaList"
            @change="onChange"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </div>
      <div class="detailAdd">
        <span>详细地址：</span>
        <textarea v-model="address"></textarea>
      </div>
      <div class="submitBox">
        <div class="submit" @click="submit">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { sendCode, userInfo } from "@/api";
import areaList from "@/assets/area.js";
export default {
  data() {
    return {
      areaList,
      showTime: true, // 是否显示倒计时
      count: "", // 倒计时秒数
      user_name: "", //收货人
      mobile: "", // 手机号
      free_code: "", //领取码
      province: "", //省份
      city: "", //城市
      district: "", //区/县
      address: "", //详细地址
      verify_code: "", // 验证码
      username: "", //收货人
      show: false, //遮罩层
      carmodel: "" //用户选定地址
    };
  },
  created() {
    this.getUrl();
  },
  methods: {
    // 获取地址中的url
    getUrl() {
      let url = window.location.href;
      this.free_code = url.split("=")[1];
    },
    // 返回活动页
    goActive() {
      this.$router.push("/activity");
    },
    // 点击获取快捷登陆验证码
    async getCode() {
      //手机号验证
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.mobile == "") {
        this.$toast({ message: "请输入手机号码", duration: "3000" });
      } else if (!reg.test(this.mobile)) {
        this.$toast({ message: "手机格式不正确", duration: "3000" });
      } else {
        window.sessionStorage.setItem("unique", this.mobile);
        let params = {
          mobile: this.mobile,
          scene: 8
        };
        let res = await sendCode(params);
        if (res.status === 1) {
          this.$toast({ message: res.msg, duration: "3000" });
          //验证码发送成功  进入倒计时
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.showTime = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.showTime = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$toast({ message: res.msg, duration: "2000" });
        }
      }
    },
    // 点击提交按钮，提交用户信息
    async submit() {
      let params = {
        mobile: this.mobile,
        free_code: this.free_code,
        province: this.province,
        city: this.city,
        district: this.district,
        address: this.address,
        verify_code: this.verify_code,
        user_name: this.user_name
      };
      let res = await userInfo(qs.stringify(params));
      if (res.status === 1) {
        this.$toast({ message: res.msg, duration: "3000" });
        this.$router.push("/activity");
      } else {
        this.$toast({ message: res.msg, duration: "3000" });
      }
    },
    showPopup() {
      this.show = true;
    },
    //value=0改变省，1改变市，2改变区
    onChange(picker, index, value) {
      let val = picker.getValues();
      let areaName = "";
      for (var i = 0; i < val.length; i++) {
        areaName = areaName + (i == 0 ? "" : "/") + val[i].name;
      }
      this.carmodel = areaName;
    },
    //确定选择城市
    onConfirm(val) {
      // this.carmodel = val[0].name + "," + val[1].name+ ','+val[2].name
      this.province = val[0].name;
      this.city = val[1].name;
      this.district = val[2].name;
      this.show = false; //关闭弹框
    },
    //取消选中城市
    onCancel() {
      this.show = false;
      this.$refs.myArea.reset(); // 重置城市列表
    }
  }
};
</script>
<style lang="less" scoped>
#userInfo {
  width: 100%;
  height: 100vh;
  position: relative;
  font-size: 18PX;
  color: #6b6b6b;
  .nav {
    position: relative;
    width: 100%;
    height: 90px;
    line-height: 90px;
    text-align: center;
    color: #000;
    border-bottom: 1px solid #a4a4a4;
    img {
      position: absolute;
      top: 30px;
      left: 50px;
      height: 30px;
    }
  }
  .userInfo {
    width: 100%;
    box-sizing: border-box;
    input {
      border: none;
      outline: none;
      height: 40px;
      width: 60%;
    }
    .box {
      width: 100%;
      box-sizing: border-box;
      position: relative;
      width: 100%;
      padding: 0 20px;
      height: 100px;
      line-height: 100px;
      border-bottom: 1px solid #e7e7e7;
      .van-cell {
        height: 80%;
        line-height: 60px;
        font-size: 18PX;
        padding-left: 0;
      }
      .van-cell__value--alone {
        color: #6b6b6b;
      }
      .van-icon-arrow:before {
        font-size: 18PX;
        margin-top: 20px;
      }
      .van-popup {
        width: 100%;
      }
    }
    .getCode {
      position: absolute;
      top: 20px;
      right: 10px;
      color: #ffffff;
      height: 60px;
      line-height: 60px;
      font-size: 16PX;
      padding: 0 20px;
      background-color: #ff5733;
    }
    .getCode1 {
      position: absolute;
      top: 20px;
      right: 10px;
      color: #ffffff;
      height: 60px;
      line-height: 60px;
      font-size: 16PX;
      padding: 0 20px;
      background-color: #cccccc;
    }
  }
  .detailAdd {
    position: relative;
    margin-top: 20px;
    border-bottom: 1px solid #e7e7e7;
    span {
      position: absolute;
      top: 10px;
      left: 0;
      padding-left: 20px;
    }
    textarea {
      border: none;
      margin-left: 200px;
      padding-left: 10px;
      width: 65%;
      height: 180px;
      resize: none;
    }
  }
  .submitBox {
    margin-top: 100px;
    width: 100%;
    height: 100px;
    color: #ffffff;
    .submit {
      margin: 0 auto;
      width: 400px;
      height: 80px;
      text-align: center;
      font-size: 16PX;
      line-height: 80px;
      border-radius: 40px;
      background-color: #ff5733;
    }
  }
}
</style>